import { useState } from "react";
import { LabelMolecule } from "..";
import { ITextValidator } from "../../../models/validator";
import { InputAtom, LabelAtom } from "../../atoms";
import { IconLabelMolecule } from "../icon-label";
import styles from "./styles.module.scss";

interface Props {
  id: string;
  placeholder?: string;
  onChange?: (value: string) => void;
  onBlur?: (value: React.ChangeEvent<HTMLInputElement>) => void;
  onEnter?: () => void;
  value?: string;
  defaultValue?: string;
  label?: string;
  tooltip?: string | string[];
  required?: boolean;
  disabled?: boolean;
  inputRef?: (ref: HTMLInputElement) => void;
  validations?: ITextValidator[];
}

interface InputProps extends Props {
  type: "text" | "email" | "password" | "date" | "time" | "radio";
}

function InputMolecule(props: Readonly<InputProps>) {
  const [hasBlurred, setHasBlurred] = useState(false);
  const onBlur = (value: React.ChangeEvent<HTMLInputElement>) => {
    setHasBlurred(true);
    if (props.onBlur) props.onBlur(value);
  };
  const errors = hasBlurred
    ? props.validations
        ?.map((validate: ITextValidator) => {
          if (props.type !== "date") return validate.validate(props.value ?? "");
          else if (props.value?.indexOf("NaN") === -1) {
            return validate.validate(props.value);
          } else return validate.validate("");
        })
        .filter((validate: string | undefined) => validate !== undefined)
    : [];
  const hasError = errors && errors?.length > 0;

  const textInputField =
    props.type === "radio" ? (
      <div className={styles.container}>
        <InputAtom {...props} id={props.id} error={hasError} onBlur={onBlur} onChange={props.onChange} />
        {props.type === "radio" && (
          <LabelAtom id={props.id + "_" + props.placeholder} type={"form"} for={props.id}>
            {props.placeholder ?? ""}
          </LabelAtom>
        )}
      </div>
    ) : (
      <InputAtom {...props} error={hasError} onBlur={onBlur} onChange={props.onChange} />
    );

  return (
    <div>
      {props.label && (
        <LabelMolecule
          id={props.id + "_label"}
          for={props.id}
          label={props.label}
          tooltip={props.tooltip}
          required={props.required}
        />
      )}
      {textInputField}
      {hasError && <IconLabelMolecule icon={"icon-alert-red"} label={errors[0] ?? ""} type={"alert"} />}
    </div>
  );
}

export function PasswordInputMolecule(props: Readonly<Props>) {
  return <InputMolecule {...props} type="password" />;
}

export function EmailInputMolecule(props: Readonly<Props>) {
  return <InputMolecule {...props} type="email" />;
}

export function TextInputMolecule(props: Readonly<Props>) {
  return <InputMolecule {...props} type="text" />;
}

export function DateInputMolecule(props: Props & { minDate?: Date }) {
  return <InputMolecule {...props} type="date" />;
}

export function TimeInputMolecule(props: Props & { minDate?: Date }) {
  return <InputMolecule {...props} type="time" />;
}

export function RadioInputMolecule(props: Readonly<Props>) {
  return <InputMolecule {...props} type="radio" />;
}
